import { Language } from '../enums';
import { AppRoutePath } from './app-route-path.const';

export type TranslatedPathRecord = Record<Language, string>;
export const translatedPaths = new Map<symbol, TranslatedPathRecord>([
	[
		AppRoutePath.Home,
		{
			[Language.English]: '/',
			[Language.Serbian]: '/',
		},
	],
	[
		AppRoutePath.Tours,
		{
			[Language.English]: 'tours',
			[Language.Serbian]: 'ture',
		},
	],
	[
		AppRoutePath.Reservation,
		{
			[Language.English]: 'reservation',
			[Language.Serbian]: 'rezervacija',
		},
	],
	[
		AppRoutePath.Hotels,
		{
			[Language.English]: 'hotels',
			[Language.Serbian]: 'hoteli',
		},
	],
	[
		AppRoutePath.AboutUs,
		{
			[Language.English]: 'about-us',
			[Language.Serbian]: 'o-nama',
		},
	],
	[
		AppRoutePath.LastMinute,
		{
			[Language.English]: 'last-minute',
			[Language.Serbian]: 'last-minute',
		},
	],
	[
		AppRoutePath.FirstMinute,
		{
			[Language.English]: 'first-minute',
			[Language.Serbian]: 'first-minute',
		},
	],
	[
		AppRoutePath.Partners,
		{
			[Language.English]: 'partners',
			[Language.Serbian]: 'partneri',
		},
	],
	[
		AppRoutePath.FlightInformation,
		{
			[Language.English]: 'flight-information',
			[Language.Serbian]: 'informacije-o-letu',
		},
	],
	[
		AppRoutePath.ComingSoon,
		{
			[Language.English]: 'coming-soon',
			[Language.Serbian]: 'uskoro',
		},
	],
	[
		AppRoutePath.AboutCyprus,
		{
			[Language.English]: 'about-cyprus',
			[Language.Serbian]: 'o-kipru',
		},
	],
	[
		AppRoutePath.Premium,
		{
			[Language.English]: 'premium',
			[Language.Serbian]: 'premium',
		},
	],
	[
		AppRoutePath.SpecialOffer,
		{
			[Language.English]: 'special-offer',
			[Language.Serbian]: 'specijalna-ponuda',
		},
	],
]);

export const allTranslatedPathRecords = Array.from(translatedPaths.values());
